(function () {
  "use strict";

  // Get section ID from the product info container specifically
  const container = document.querySelector(".ra-v2-product-info[data-section-id]");
  const sectionId = container ? container.getAttribute("data-section-id") : "";

  const gallery = document.querySelector("[data-ra-v2-gallery]");
  // Don't return early - we need GPO price sync even without gallery

  // Gallery is now handled by Swiper - initialized in the liquid template
  // This file handles variant changes, modals, and form submission

  function getVariantStockData() {
    const el = document.getElementById("VariantStockData-" + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getVariantPreorderInfo(variant) {
    const empty = { isPreorder: false, preorderDate: "" };
    if (!variant) return empty;
    const stockData = getVariantStockData();
    if (!stockData) return empty;
    const variants = stockData.variants || stockData;
    const vData = variants[String(variant.id)];
    if (!vData) return empty;

    const variantDate = vData.preorder_date != null ? String(vData.preorder_date).trim() : "";
    const productDate = stockData.product_preorder_date != null ? String(stockData.product_preorder_date).trim() : "";
    const preorderDate = variantDate || productDate || "";

    let isPreorder = false;
    if (preorderDate !== "") {
      isPreorder = true;
    } else if (vData.inventory_policy === "continue" && vData.inventory_quantity <= 0) {
      isPreorder = true;
    }
    return { isPreorder: isPreorder, preorderDate: preorderDate };
  }

  function setBuyButtonForVariant(buyButton, variant) {
    if (!buyButton || !variant) return;
    if (!variant.available) {
      buyButton.textContent = "Sold Out";
      buyButton.disabled = true;
      return;
    }
    const { isPreorder } = getVariantPreorderInfo(variant);
    if (isPreorder) {
      buyButton.textContent = "Pre-order Now";
      buyButton.disabled = false;
      return;
    }
    const formattedPrice = formatRaV2DisplayPrice(variant.price);
    buyButton.textContent = `Checkout Now - ${formattedPrice}`;
    buyButton.disabled = false;
  }

  function updateVariantNotice(variant) {
    const noticeEl = document.querySelector("[data-variant-notice]");
    if (!noticeEl) return;

    // Hide server-rendered preorder-notice once JS takes over (variant-notice handles all states)
    const serverPreorderEl = document.querySelector("[data-preorder-notice]");
    if (serverPreorderEl) {
      serverPreorderEl.style.display = "none";
      serverPreorderEl.classList.remove("ra-v2-preorder-notice--visible");
    }

    const stockData = getVariantStockData();
    const iconEl = noticeEl.querySelector("[data-notice-icon]");
    const textEl = noticeEl.querySelector("[data-notice-text]");
    if (!textEl || !iconEl) return;

    const variants = stockData && stockData.variants ? stockData.variants : stockData;
    const vData = variants && variant ? variants[String(variant.id)] : null;
    const isSoldOut = variant ? !variant.available : false;
    const preorderInfo = getVariantPreorderInfo(variant);
    const isPreorder = variant && variant.available ? preorderInfo.isPreorder : false;
    const preorderDate = preorderInfo.preorderDate;
    const variantTitle = vData ? vData.title : variant ? variant.title : "";

    const clockSvg =
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 4.667V8l2 2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const infoSvg =
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 5.333V8M8 10.667h.007" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    noticeEl.classList.remove("ra-v2-variant-notice--soldout", "ra-v2-variant-notice--preorder", "ra-v2-variant-notice--visible");

    if (isSoldOut) {
      const sectionEl = document.querySelector(".ra-v2-product-info[data-section-id]");
      const tpl = sectionEl ? sectionEl.getAttribute("data-soldout-template") : null;
      const msg = tpl
        ? tpl.replace("[variant]", "<strong>" + variantTitle + "</strong>")
        : "<strong>" + variantTitle + "</strong> is currently sold out.";
      textEl.innerHTML = msg;
      iconEl.innerHTML = infoSvg;
      noticeEl.classList.add("ra-v2-variant-notice--soldout", "ra-v2-variant-notice--visible");
      noticeEl.style.display = "";
    } else if (isPreorder) {
      const shipPhrase = preorderDate
        ? "will ship starting " + preorderDate + "."
        : "will ship as soon as stock is available.";
      textEl.innerHTML =
        "<strong>Pre-order notice:</strong> Due to high demand, orders for <strong>" +
        variantTitle +
        "</strong> " +
        shipPhrase;
      iconEl.innerHTML = clockSvg;
      noticeEl.classList.add("ra-v2-variant-notice--preorder", "ra-v2-variant-notice--visible");
      noticeEl.style.display = "";
    } else {
      noticeEl.style.display = "none";
      textEl.innerHTML = "";
    }
  }

  function formatRaV2DisplayPrice(cents) {
    return new Intl.NumberFormat(Shopify.locale || "en-US", {
      style: "currency",
      currency: Shopify.currency.active || "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number(cents) / 100);
  }

  function renderRaV2PriceContainerHtml(variant) {
    if (!variant) return "";
    const price = variant.price;
    const compare = variant.compare_at_price;
    const formatted = formatRaV2DisplayPrice(price);
    if (compare && compare > price) {
      return (
        '<div class="price price--on-sale">' +
        '<div class="price__container">' +
        '<div class="price__sale">' +
        '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
        "<span><s class=\"price-item price-item--regular\">" +
        formatRaV2DisplayPrice(compare) +
        "</s></span>" +
        '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
        '<span class="price-item price-item--sale price-item--last">' +
        formatted +
        "</span>" +
        "</div></div></div>"
      );
    }
    return (
      '<div class="price">' +
      '<div class="price__container">' +
      '<div class="price__regular">' +
      '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
      '<span class="price-item price-item--regular">' +
      formatted +
      "</span>" +
      "</div></div></div>"
    );
  }

  function updateRaV2PriceContainer(variant) {
    const el = document.querySelector("[data-price-container]");
    if (!el || !variant) return;
    el.innerHTML = renderRaV2PriceContainerHtml(variant);
  }

  // Initialize variant from URL on page load
  document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromUrl = urlParams.get("variant");

    if (variantIdFromUrl) {
      selectVariantFromUrl(variantIdFromUrl);
    }
  });

  function selectVariantFromUrl(variantId) {
    const productJson = document.getElementById("Product-" + sectionId);
    if (!productJson) return;

    try {
      const productData = JSON.parse(productJson.textContent);
      const variant = productData.variants.find((v) => v.id == variantId);

      if (!variant) return;

      // Update the form selects/buttons to match this variant
      const form = document.getElementById("ra-v2-product-form");
      if (!form) return;

      // Update option selects
      const optionSelects = form.querySelectorAll('select[name^="options"]');
      variant.options.forEach((optionValue, index) => {
        if (optionSelects[index]) {
          optionSelects[index].value = optionValue;
        }
      });

      // Update option buttons
      const optionContainers = form.querySelectorAll(".ra-v2-info__option");
      optionContainers.forEach((container, index) => {
        const buttons = container.querySelectorAll(".ra-v2-info__option-button");
        buttons.forEach((button) => {
          button.classList.remove("ra-v2-info__option-button--active");
          if (button.dataset.value === variant.options[index]) {
            button.classList.add("ra-v2-info__option-button--active");
          }
        });
      });

      // Update the hidden variant ID input
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variantId;
      }

      // Update buy button (Sold Out / Pre-order Now / Checkout Now)
      const buyButton = form.querySelector(".ra-v2-info__button");
      setBuyButtonForVariant(buyButton, variant);

      updateRaV2PriceContainer(variant);

      // Update variant notice (sold-out / pre-order)
      updateVariantNotice(variant);

      // Update Auglio Try-On button with variant SKU
      const tryOnBtn = document.querySelector(".ra-v2-gallery__tryon");
      if (tryOnBtn && variant.sku) {
        tryOnBtn.setAttribute("data-auglio-sku", variant.sku);
        tryOnBtn.setAttribute("onclick", `if(window.AuglioWidget){window.AuglioWidget.open('${variant.sku}')}`);
      }

      // Update gallery to show variant image - wait for Swiper to be ready
      if (variant.featured_image) {
        const waitForSwiper = setInterval(() => {
          if (window.raV2GallerySwiper) {
            clearInterval(waitForSwiper);

            // Find the slide index that matches the variant image
            const slides = document.querySelectorAll(".ra-v2-gallery-swiper .swiper-slide");
            let targetSlideIndex = -1;

            const variantImageSrc = variant.featured_image.src.split("?")[0];

            slides.forEach((slide, index) => {
              const img = slide.querySelector("img");
              if (img) {
                const imgSrc = img.src.split("?")[0];
                if (imgSrc.includes(variantImageSrc.split("/").pop())) {
                  targetSlideIndex = index;
                }
              }
            });

            if (targetSlideIndex >= 0) {
              window.raV2GallerySwiper.slideTo(targetSlideIndex, 0);
            }
          }
        }, 100);

        // Stop checking after 3 seconds
        setTimeout(() => clearInterval(waitForSwiper), 3000);
      }
    } catch (e) {
      console.error("Error selecting variant from URL:", e);
    }
  }

  // Variant change handler
  const form = document.getElementById("ra-v2-product-form");
  if (form) {
    const variantSelects = form.querySelectorAll('select[name^="options"]');
    variantSelects.forEach((select) => {
      select.addEventListener("change", () => {
        updateVariant();
      });
    });

    // Gift card variant selector
    const giftCardSelect = form.querySelector("[data-gift-card-variant-selector]");
    if (giftCardSelect) {
      giftCardSelect.addEventListener("change", function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantId = selectedOption.dataset.variantId;
        const variantPrice = parseInt(selectedOption.dataset.variantPrice, 10);
        const variantAvailable = selectedOption.dataset.variantAvailable === "true";

        // Update hidden variant ID input
        const hiddenInput = form.querySelector('input[name="id"]');
        if (hiddenInput) {
          hiddenInput.value = variantId;
        }

        // Format the price
        const formattedPrice = formatRaV2DisplayPrice(variantPrice);

        updateRaV2PriceContainer({ price: variantPrice, compare_at_price: null });

        // Update buy button
        const buyButton = form.querySelector(".ra-v2-info__button");
        if (buyButton) {
          if (variantAvailable) {
            buyButton.textContent = "Add to Cart - " + formattedPrice;
            buyButton.disabled = false;
          } else {
            buyButton.textContent = "Sold Out";
            buyButton.disabled = true;
          }
        }

        // Update URL
        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", variantId);
          window.history.replaceState({}, "", url.toString());
        }
      });
    }
  }

  // Slide gallery to a specific index
  function slideGalleryTo(slideIndex) {
    if (slideIndex >= 0 && window.raV2GallerySwiper) {
      window.raV2GallerySwiper.slideTo(slideIndex, 300);
    }
  }

  // Sync all selects in the form that share the same name attribute
  function syncSelectValue(selectEl, value) {
    var f = document.getElementById("ra-v2-product-form");
    if (f && selectEl) {
      var selectName = selectEl.name;
      f.querySelectorAll('select[name="' + selectName + '"]').forEach(function (s) {
        s.value = value;
      });
    }
  }

  // Use event delegation for all swatch/button clicks
  // This ensures handlers work even if DOM elements are recreated by other scripts (GPO, etc.)
  document.addEventListener("click", function (e) {
    // Variant button picker
    var button = e.target.closest(".ra-v2-info__option-button");
    if (button) {
      var optionContainer = button.closest(".ra-v2-info__option");
      if (optionContainer) {
        optionContainer.querySelectorAll(".ra-v2-info__option-button").forEach(function (btn) {
          btn.classList.remove("ra-v2-info__option-button--active");
        });
        button.classList.add("ra-v2-info__option-button--active");
        var select = optionContainer.querySelector("select");
        if (select && button.dataset.value) {
          select.value = button.dataset.value;
          select.dispatchEvent(new Event("change"));
        }
        updateVariant();
      }
      return;
    }

    // Color swatch picker (variant_picker block)
    var colorSwatch = e.target.closest(".ra-v2-info__color-swatch");
    if (colorSwatch) {
      var optionContainer = colorSwatch.closest(".ra-v2-info__option");
      if (optionContainer) {
        optionContainer.querySelectorAll(".ra-v2-info__color-swatch").forEach(function (s) {
          s.classList.remove("ra-v2-info__color-swatch--active");
        });
        colorSwatch.classList.add("ra-v2-info__color-swatch--active");
        var select = optionContainer.querySelector("select");
        if (select && colorSwatch.dataset.value) {
          select.value = colorSwatch.dataset.value;
          syncSelectValue(select, colorSwatch.dataset.value);
          select.dispatchEvent(new Event("change"));
        }
        updateVariant();
        if (colorSwatch.dataset.slideIndex !== undefined) {
          slideGalleryTo(parseInt(colorSwatch.dataset.slideIndex));
        } else {
          updateGalleryForColorChange();
        }
      }
      return;
    }

    // Frame Color Picker block swatches
    var frameSwatch = e.target.closest(".ra-v2-info__frame-color-swatch");
    if (frameSwatch) {
      var container = frameSwatch.closest(".ra-v2-info__frame-color");
      if (container) {
        container.querySelectorAll(".ra-v2-info__frame-color-swatch").forEach(function (s) {
          s.classList.remove("ra-v2-info__frame-color-swatch--active");
        });
        frameSwatch.classList.add("ra-v2-info__frame-color-swatch--active");

        if (container.classList.contains("ra-v2-info__frame-color--bundle")) {
          container.querySelectorAll("select").forEach(function (select) {
            if (frameSwatch.dataset.value) {
              select.value = frameSwatch.dataset.value;
              syncSelectValue(select, frameSwatch.dataset.value);
              select.dispatchEvent(new Event("change"));
            }
          });
        } else {
          var select = container.querySelector("select");
          if (select && frameSwatch.dataset.value) {
            select.value = frameSwatch.dataset.value;
            syncSelectValue(select, frameSwatch.dataset.value);
            select.dispatchEvent(new Event("change"));
          }
        }

        updateVariant();

        if (frameSwatch.dataset.slideIndex !== undefined) {
          slideGalleryTo(parseInt(frameSwatch.dataset.slideIndex));
        } else {
          updateGalleryForColorChange();
        }
      }
      return;
    }
  });

  // Update gallery when color changes
  function updateGalleryForColorChange() {
    const form = document.getElementById("ra-v2-product-form");
    if (!form) return;

    const hiddenInput = form.querySelector('input[name="id"]');
    if (!hiddenInput) return;

    const variantId = hiddenInput.value;
    const productJson = document.getElementById("Product-" + sectionId);
    if (!productJson) return;

    try {
      const productData = JSON.parse(productJson.textContent);
      const variant = productData.variants.find((v) => v.id == variantId);

      if (variant && variant.featured_image && window.raV2GallerySwiper) {
        // Find the slide index that matches the variant image
        const slides = document.querySelectorAll(".ra-v2-gallery-swiper .swiper-slide");
        let targetSlideIndex = -1;

        const variantImageSrc = variant.featured_image.src.split("?")[0];

        slides.forEach((slide, index) => {
          const img = slide.querySelector("img");
          if (img) {
            const imgSrc = img.src.split("?")[0];
            if (imgSrc.includes(variantImageSrc.split("/").pop())) {
              targetSlideIndex = index;
            }
          }
        });

        if (targetSlideIndex >= 0) {
          window.raV2GallerySwiper.slideTo(targetSlideIndex, 300);
        }
      }
    } catch (e) {
      console.error("Error updating gallery for color change:", e);
    }
  }

  function updateVariant() {
    if (!form) return;

    // Get selected options from form (deduplicate by option name)
    const selectedOptions = {};
    const optionSelects = form.querySelectorAll('select[name^="options"]');
    optionSelects.forEach((select) => {
      const optionName = select.name.replace("options[", "").replace("]", "");
      if (!(optionName in selectedOptions)) {
        selectedOptions[optionName] = select.value;
      }
    });

    // Also read from active option buttons/swatches as fallback
    const optionContainers = form.querySelectorAll(".ra-v2-info__option");
    optionContainers.forEach((container) => {
      const label = container.querySelector("label");
      if (!label) return;
      const optionName = label.textContent.trim();
      if (optionName in selectedOptions) return;
      const activeBtn = container.querySelector(".ra-v2-info__option-button--active, .ra-v2-info__color-swatch--active");
      if (activeBtn && activeBtn.dataset.value) {
        selectedOptions[optionName] = activeBtn.dataset.value;
      }
    });

    // Also read from active frame color swatches
    const frameColorContainers = form.querySelectorAll(".ra-v2-info__frame-color");
    frameColorContainers.forEach((container) => {
      const label = container.querySelector("label, .ra-v2-info__frame-color-label");
      if (!label) return;
      const labelText = label.textContent.trim();
      const select = container.querySelector("select");
      const optionName = select ? select.name.replace("options[", "").replace("]", "") : labelText;
      if (optionName in selectedOptions) return;
      const activeSwatch = container.querySelector(".ra-v2-info__frame-color-swatch--active");
      if (activeSwatch && activeSwatch.dataset.value) {
        selectedOptions[optionName] = activeSwatch.dataset.value;
      }
    });

    // Find matching variant
    const productJson = document.getElementById("Product-" + sectionId);

    if (productJson) {
      try {
        const productData = JSON.parse(productJson.textContent);
        const variants = productData.variants;
        const options = productData.options;

        // Find variant that matches selected options
        let selectedVariant = null;
        for (const variant of variants) {
          let matches = true;
          for (let i = 0; i < options.length; i++) {
            const optionName = options[i];
            const variantOptionValue = variant.options[i];
            if (selectedOptions[optionName] && selectedOptions[optionName] !== variantOptionValue) {
              matches = false;
              break;
            }
          }
          if (matches) {
            selectedVariant = variant;
            break;
          }
        }

        // Fallback to first available variant if no match
        if (!selectedVariant) {
          selectedVariant = variants.find((v) => v.available) || variants[0];
        }

        if (selectedVariant) {
          // Update variant ID in hidden input
          const hiddenInput = form.querySelector('input[name="id"]');
          if (hiddenInput) {
            hiddenInput.value = selectedVariant.id;
          }

          // Update button label (Sold Out / Pre-order Now / Checkout Now)
          const buyButton = form.querySelector(".ra-v2-info__button");
          setBuyButtonForVariant(buyButton, selectedVariant);

          updateRaV2PriceContainer(selectedVariant);

          // Update variant notice (sold-out / pre-order)
          updateVariantNotice(selectedVariant);

          // Update Auglio Try-On button with new variant SKU
          const tryOnBtn = document.querySelector(".ra-v2-gallery__tryon");
          if (tryOnBtn && selectedVariant.sku) {
            tryOnBtn.setAttribute("data-auglio-sku", selectedVariant.sku);
            tryOnBtn.setAttribute("onclick", `if(window.AuglioWidget){window.AuglioWidget.open('${selectedVariant.sku}')}`);
          }

          // Trigger GPO price recalculation after variant change
          setTimeout(function () {
            if (typeof window.raV2UpdatePrices === "function") {
              window.raV2UpdatePrices();
            }
          }, 100);
        }
      } catch (e) {
        console.error("Error updating variant:", e);
      }
    }
  }

  // Initialize Auglio when page loads
  document.addEventListener("DOMContentLoaded", function () {
    // Wait for Auglio to load
    const checkAuglio = setInterval(function () {
      if (window.AuglioWidget) {
        clearInterval(checkAuglio);

        // Initialize Auglio for current product
        const tryOnBtn = document.querySelector(".ra-v2-gallery__tryon");
        if (tryOnBtn) {
          const sku = tryOnBtn.getAttribute("data-auglio-sku");
        }
      }
    }, 500);

    // Stop checking after 10 seconds
    setTimeout(function () {
      clearInterval(checkAuglio);
    }, 10000);
  });

  // Quantity selector
  const quantityControls = document.querySelectorAll(".ra-v2-info__quantity-controls");
  quantityControls.forEach((controls) => {
    const decreaseBtn = controls.querySelector('[data-action="decrease"]');
    const increaseBtn = controls.querySelector('[data-action="increase"]');
    const input = controls.querySelector(".ra-v2-info__quantity-input");

    if (decreaseBtn && input) {
      decreaseBtn.addEventListener("click", () => {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      });
    }

    if (increaseBtn && input) {
      increaseBtn.addEventListener("click", () => {
        const currentValue = parseInt(input.value) || 1;
        input.value = currentValue + 1;
      });
    }
  });

  // Bundle modal functionality
  function initBundleModal() {
    const bundleTriggers = document.querySelectorAll("[data-bundle-trigger]");
    const bundleModal = document.querySelector("#BundleSaveModal-" + sectionId);

    if (!bundleModal || bundleTriggers.length === 0) return;

    if (!bundleModal.show) {
      bundleModal.show = function (opener) {
        this.setAttribute("open", "");
        document.body.style.overflow = "hidden";
        positionBundleModal(this, opener);
      };

      bundleModal.hide = function () {
        this.removeAttribute("open");
        document.body.style.overflow = "";
      };
    }

    bundleTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        bundleModal.show(trigger);
      });

      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          bundleModal.show(trigger);
        }
      });
    });

    const closeBtn = bundleModal.querySelector(".ra-v2-bundle-save-modal__close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        bundleModal.hide();
      });
    }

    bundleModal.addEventListener("click", (e) => {
      if (e.target === bundleModal) {
        bundleModal.hide();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && bundleModal.hasAttribute("open")) {
        bundleModal.hide();
      }
    });
  }

  function positionBundleModal(modal, trigger) {
    if (!modal || !trigger) return;

    const modalContent = modal.querySelector(".ra-v2-bundle-save-modal__content");
    if (!modalContent) return;

    requestAnimationFrame(() => {
      if (window.innerWidth < 990) {
        modalContent.style.top = "auto";
        modalContent.style.left = "auto";
        modalContent.style.transform = "none";
        return;
      }

      const triggerRect = trigger.getBoundingClientRect();
      const modalContentRect = modalContent.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let top = triggerRect.bottom + 16;
      let left = triggerRect.left;

      if (left + modalContentRect.width > viewportWidth - 20) {
        left = viewportWidth - modalContentRect.width - 20;
      }

      if (left < 20) {
        left = 20;
      }

      if (top + modalContentRect.height > viewportHeight - 20) {
        top = triggerRect.top - modalContentRect.height - 16;
        if (top < 20) {
          top = Math.max(20, (viewportHeight - modalContentRect.height) / 2);
        }
      }

      if (top < 20) {
        top = 20;
      }

      modalContent.style.top = `${top}px`;
      modalContent.style.left = `${left}px`;
      modalContent.style.transform = "translateY(0)";
    });
  }

  // Initialize bundle modal
  initBundleModal();

  // Lens Comparison Modal functionality
  function positionLensComparisonModal(modal, trigger) {
    if (!modal || !trigger) return;

    const modalContent = modal.querySelector(".ra-v2-lens-comparison-modal__content");
    if (!modalContent) return;

    requestAnimationFrame(() => {
      if (window.innerWidth < 990) {
        modalContent.style.top = "auto";
        modalContent.style.left = "auto";
        modalContent.style.transform = "none";
        return;
      }

      const lensSection = trigger.closest(".ra-v2-info__section");
      if (!lensSection) return;

      const lensSectionRect = lensSection.getBoundingClientRect();
      const modalContentRect = modalContent.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let top = lensSectionRect.top;
      let left = lensSectionRect.left;

      if (left + modalContentRect.width > viewportWidth - 20) {
        left = viewportWidth - modalContentRect.width - 20;
      }

      if (left < 20) {
        left = 20;
      }

      if (top + modalContentRect.height > viewportHeight - 20) {
        top = viewportHeight - modalContentRect.height - 20;
        if (top < 20) {
          top = Math.max(20, (viewportHeight - modalContentRect.height) / 2);
        }
      }

      if (top < 20) {
        top = 20;
      }

      modalContent.style.top = top + "px";
      modalContent.style.left = left + "px";
      modalContent.style.transform = "none";
    });
  }

  function initLensComparisonModal() {
    const lensComparisonTriggers = document.querySelectorAll("[data-lens-comparison-trigger]");
    const lensComparisonModal = document.querySelector("#LensComparisonModal-" + sectionId);

    if (!lensComparisonModal || lensComparisonTriggers.length === 0) return;

    if (!lensComparisonModal.show) {
      lensComparisonModal.show = function (opener) {
        this.setAttribute("open", "");
        document.body.style.overflow = "hidden";
        positionLensComparisonModal(this, opener);
      };

      lensComparisonModal.hide = function () {
        this.removeAttribute("open");
        document.body.style.overflow = "";
      };
    }

    lensComparisonTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        lensComparisonModal.show(trigger);
      });
    });

    const closeBtn = lensComparisonModal.querySelector(".ra-v2-lens-comparison-modal__close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        lensComparisonModal.hide();
      });
    }

    lensComparisonModal.addEventListener("click", (e) => {
      if (e.target === lensComparisonModal) {
        lensComparisonModal.hide();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && lensComparisonModal.hasAttribute("open")) {
        lensComparisonModal.hide();
      }
    });
  }

  initLensComparisonModal();

  function initSizeChartModal() {
    const sizeChartTriggers = document.querySelectorAll("[data-size-chart-trigger]");
    const sizeChartModal = document.querySelector("#SizeChartModal-" + sectionId);

    if (!sizeChartModal || sizeChartTriggers.length === 0) return;

    if (!sizeChartModal.show) {
      sizeChartModal.show = function () {
        this.setAttribute("open", "");
        document.body.style.overflow = "hidden";
      };

      sizeChartModal.hide = function () {
        this.removeAttribute("open");
        document.body.style.overflow = "";
      };
    }

    sizeChartTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        sizeChartModal.show();
      });
    });

    const closeBtn = sizeChartModal.querySelector(".ra-v2-size-chart-modal__close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        sizeChartModal.hide();
      });
    }

    sizeChartModal.addEventListener("click", (e) => {
      if (e.target === sizeChartModal) {
        sizeChartModal.hide();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && sizeChartModal.hasAttribute("open")) {
        sizeChartModal.hide();
      }
    });
  }

  initSizeChartModal();

  // Ensure lens swatch links work properly (they're inside a form)
  const lensSwatches = document.querySelectorAll(".ra-v2-info__lens-swatch");
  lensSwatches.forEach((swatch) => {
    swatch.addEventListener("click", (e) => {
      const href = swatch.getAttribute("href");
      if (href && href !== "#" && href !== "") {
        e.stopPropagation();
        window.location.href = href;
      } else {
        e.preventDefault();
      }
    });
  });

  // Form submission
  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      const variantId = formData.get("id");

      if (!variantId) {
        alert("Please select a variant");
        return;
      }

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        if (response.ok) {
          const cartData = await response.clone().json();

          // Klaviyo Onsite "Added to Cart" tracking
          try {
            if (typeof klaviyo !== "undefined" && cartData) {
              var pJson = document.getElementById("Product-" + sectionId);
              var pData = pJson ? JSON.parse(pJson.textContent) : null;
              var variant = pData?.variants?.find((v) => v.id == variantId);
              klaviyo.track("Added to Cart", {
                $value: parseFloat(cartData.final_line_price || cartData.price) / 100,
                AddedItemProductName: cartData.product_title || cartData.title,
                AddedItemProductID: cartData.product_id,
                AddedItemSKU: cartData.sku || variant?.sku || "",
                AddedItemVariantName: cartData.variant_title || "",
                AddedItemVariantID: cartData.variant_id || variantId,
                AddedItemImageURL: cartData.featured_image?.url || cartData.image || "",
                AddedItemURL: window.location.origin + (cartData.url || window.location.pathname),
                AddedItemPrice: parseFloat(cartData.final_price || cartData.price) / 100,
                AddedItemQuantity: cartData.quantity || 1,
                ItemNames: [cartData.product_title || cartData.title],
                CheckoutURL: window.location.origin + "/checkout",
                Items: [
                  {
                    ProductID: cartData.product_id,
                    SKU: cartData.sku || variant?.sku || "",
                    ProductName: cartData.product_title || cartData.title,
                    Quantity: cartData.quantity || 1,
                    ItemPrice: parseFloat(cartData.final_price || cartData.price) / 100,
                    RowTotal: parseFloat(cartData.final_line_price || cartData.price) / 100,
                    ProductURL: window.location.origin + (cartData.url || window.location.pathname),
                    ImageURL: cartData.featured_image?.url || cartData.image || "",
                    ProductCategories: cartData.product_type ? [cartData.product_type] : [],
                  },
                ],
              });
            }
          } catch (klaviyoErr) {
            console.error("Klaviyo tracking error:", klaviyoErr);
          }

          document.dispatchEvent(new CustomEvent("cart:update"));
          window.location.href = "/cart";
        } else {
          const error = await response.json();
          alert("Unable to add product to cart. Please try again.");
          console.error("Add to cart error:", error);
        }
      } catch (error) {
        console.error("Submit error:", error);
        alert("An error occurred. Please try again.");
      }
    });
  }

  // ==========================================
  // GPO (Globo Product Options) Variant Price Sync
  // ==========================================
  // Prescription type is a VARIANT (Non-Prescription, Readers, Prescription)
  // Listen for GPO prescription changes and update variant + price

  function initGPOPriceSync() {
    // Find the prescription select (Globo's select element)
    function findPrescriptionSelect() {
      return (
        document.querySelector(".gpo-app select#select-6") ||
        document.querySelector('.gpo-app select[data-field-name="Prescription Type"]') ||
        document.querySelector('.gpo-app select[name="Prescription Type"]') ||
        document.querySelector('.gpo-app select[data-field-name="Prescription"]')
      );
    }

    function formatPrice(cents) {
      return new Intl.NumberFormat(Shopify.locale || "en-US", {
        style: "currency",
        currency: Shopify.currency.active || "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(cents / 100);
    }

    // Get product data
    function getProductData() {
      // Try with sectionId first
      let productJson = document.getElementById("Product-" + sectionId);

      // Fallback: find any Product JSON on the page
      if (!productJson) {
        productJson = document.querySelector('script[id^="Product-"]');
      }

      // Another fallback: ProductVariants JSON
      if (!productJson) {
        productJson = document.querySelector('script[id^="ProductVariants-"]');
        if (productJson) {
          try {
            // ProductVariants is just the variants array
            const variants = JSON.parse(productJson.textContent);
            return { variants: variants, options: [] };
          } catch (e) {
            return null;
          }
        }
      }

      if (!productJson) {
        return null;
      }

      try {
        return JSON.parse(productJson.textContent);
      } catch (e) {
        return null;
      }
    }

    // Check if two option values match (strict matching to avoid "non-prescription" matching "prescription")
    function optionValuesMatch(value1, value2) {
      const v1 = value1.toLowerCase().trim();
      const v2 = value2.toLowerCase().trim();

      // Exact match
      if (v1 === v2) return true;

      // For prescription matching, be strict to avoid "non-prescription" matching "prescription"
      if (v1 === "prescription" || v2 === "prescription") {
        return v1 === v2;
      }
      if (v1 === "non-prescription" || v2 === "non-prescription") {
        return v1 === v2;
      }

      // For other values, allow partial matching
      return v1.includes(v2) || v2.includes(v1);
    }

    // Find variant matching prescription type AND other selected options
    function findMatchingVariant(prescriptionValue) {
      const productData = getProductData();
      if (!productData || !productData.variants) return null;

      const prescriptionLower = prescriptionValue.toLowerCase().trim();

      // Get all currently selected options from the form
      const form = document.getElementById("ra-v2-product-form");
      const selectedOptions = {};
      if (form) {
        const optionSelects = form.querySelectorAll('select[name^="options"]');
        optionSelects.forEach((select) => {
          if (select.value) {
            selectedOptions[select.value.toLowerCase().trim()] = true;
          }
        });
      }

      // Also add the prescription value we're trying to match
      selectedOptions[prescriptionLower] = true;

      // Find variant that matches ALL selected options
      for (const variant of productData.variants) {
        let allMatch = true;

        // Check if prescription matches
        let hasPrescription = false;
        for (const optionValue of variant.options) {
          if (optionValuesMatch(optionValue, prescriptionLower)) {
            hasPrescription = true;
            break;
          }
        }

        if (!hasPrescription) continue;

        // Check if all other selected options match
        for (const optionValue of variant.options) {
          const optionValueLower = optionValue.toLowerCase().trim();
          if (optionValuesMatch(optionValue, prescriptionLower)) {
            continue;
          }
          let foundInSelected = false;
          for (const selectedVal in selectedOptions) {
            if (optionValuesMatch(optionValueLower, selectedVal)) {
              foundInSelected = true;
              break;
            }
          }
          if (Object.keys(selectedOptions).length > 1 && !foundInSelected) {
            allMatch = false;
            break;
          }
        }

        if (allMatch) {
          return variant;
        }
      }

      // Fallback: return first variant with matching prescription
      for (const variant of productData.variants) {
        for (const optionValue of variant.options) {
          if (optionValuesMatch(optionValue, prescriptionLower)) {
            return variant;
          }
        }
      }

      return null;
    }

    // Update displayed prices based on GPO selection
    function updatePricesWithGPO() {
      const form = document.getElementById("ra-v2-product-form");
      if (!form) return;

      const buyButton = form.querySelector(".ra-v2-info__button");
      const priceContainer = document.querySelector("[data-price-container]");
      const hiddenVariantInput = form.querySelector('input[name="id"]');

      // Get prescription select value
      const prescriptionSelect = findPrescriptionSelect();
      if (!prescriptionSelect || !prescriptionSelect.value) {
        return;
      }

      const prescriptionValue = prescriptionSelect.value;

      // Find the matching variant
      const matchingVariant = findMatchingVariant(prescriptionValue);

      if (matchingVariant) {
        const price = matchingVariant.price;
        const formattedPrice = formatPrice(price);

        // Update hidden variant ID - THIS IS CRITICAL for cart
        if (hiddenVariantInput) {
          hiddenVariantInput.value = matchingVariant.id;
        }

        // Also update any other variant ID inputs in the form
        const allVariantInputs = form.querySelectorAll('input[name="id"]');
        allVariantInputs.forEach((input) => {
          input.value = matchingVariant.id;
        });

        // Update buy button (Sold Out / Pre-order Now / Checkout Now)
        if (buyButton) {
          setBuyButtonForVariant(buyButton, matchingVariant);
          if (matchingVariant.available) {
            buyButton.setAttribute("data-button-price", price);
            buyButton.setAttribute("data-variant-id", matchingVariant.id);
          }
        }

        // Update price container display
        if (priceContainer) {
          const comparePrice = matchingVariant.compare_at_price;

          if (comparePrice && comparePrice > price) {
            priceContainer.innerHTML = `
            <div class="price price--on-sale">
              <div class="price__container">
                <div class="price__sale">
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span><s class="price-item price-item--regular">${formatPrice(comparePrice)}</s></span>
                  <span class="visually-hidden visually-hidden--inline">Sale price</span>
                  <span class="price-item price-item--sale price-item--last">${formattedPrice}</span>
                </div>
              </div>
            </div>
          `;
          } else {
            priceContainer.innerHTML = `
            <div class="price">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span class="price-item price-item--regular">${formattedPrice}</span>
                </div>
              </div>
            </div>
          `;
          }
        }

        // Update URL with variant ID (without page reload)
        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", matchingVariant.id);
          window.history.replaceState({}, "", url.toString());
        }

        // Dispatch custom event for other scripts to know variant changed
        document.dispatchEvent(
          new CustomEvent("variant:changed", {
            detail: { variant: matchingVariant },
          })
        );
      }
    }

    // Listen for changes on the prescription select
    function attachPrescriptionListener() {
      const prescriptionSelect = findPrescriptionSelect();
      if (!prescriptionSelect) return false;

      if (prescriptionSelect.dataset.raV2Listening === "1") return true;

      prescriptionSelect.addEventListener("change", () => {
        updatePricesWithGPO();
        setTimeout(updatePricesWithGPO, 100);
        setTimeout(updatePricesWithGPO, 300);
      });

      prescriptionSelect.dataset.raV2Listening = "1";
      return true;
    }

    // Also listen for clicks on the custom radio buttons
    function attachRadioListener() {
      const radioButtons = document.querySelectorAll(".ra-gpo-radio-row");
      radioButtons.forEach((btn) => {
        if (btn.dataset.raV2Listening === "1") return;

        btn.addEventListener("click", () => {
          setTimeout(updatePricesWithGPO, 50);
          setTimeout(updatePricesWithGPO, 150);
          setTimeout(updatePricesWithGPO, 350);
        });

        btn.dataset.raV2Listening = "1";
      });

      return radioButtons.length > 0;
    }

    // Watch for GPO elements to appear dynamically
    function initWithRetry() {
      let attempts = 0;
      const maxAttempts = 30;

      const tryInit = () => {
        attempts++;
        const selectFound = attachPrescriptionListener();
        const radioFound = attachRadioListener();

        if (selectFound || radioFound) {
          setTimeout(updatePricesWithGPO, 500);
          return;
        }

        if (attempts < maxAttempts) {
          setTimeout(tryInit, 500);
        }
      };

      tryInit();
    }

    // Observe DOM for GPO elements being added
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          attachPrescriptionListener();
          attachRadioListener();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Start initialization
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initWithRetry);
    } else {
      initWithRetry();
    }

    // Expose update function globally for GPO to call
    window.raV2UpdatePrices = updatePricesWithGPO;
  }

  // Initialize GPO price sync
  initGPOPriceSync();
})();
